import React from 'react';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap">
      <ol className="flex items-center">
        <li className="flex flex-col items-start pt-px pr-2 pb-1.5 text-sm text-stone-300">
          <button
            onClick={handleHomeClick}
            className="font-medium text-stone-300 hover:text-stone-400 cursor-pointer transition-colors focus:outline-none focus:text-stone-400"
            aria-label="Navigate to home"
          >
            Home /
          </button>
        </li>
        <li className="pt-px pr-2 pb-1.5 text-xs whitespace-nowrap text-neutral-700" aria-current="page">
          <span className="font-medium text-neutral-700">Products</span>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
